module.exports = __webpack_public_path__ + "img/electronic_pending_zone.1aaa1ff0.svg";